'use client';

import { usePathname } from 'next/navigation';
import { Compass } from 'lucide-react';
import { useOptionalTour } from '@/components/client/tour/TourContext';
import {
  buildSharprTourSteps,
  buildSignedOutSharprTourSteps,
  tourSportFromPath,
} from '@/components/client/tour/tourSteps';
import { useSession } from '@/hooks/useSession';
import { useAccess } from '@/hooks/useAccess';

/** Launches the product walkthrough from the How-To-Use page. The tour's first
 *  step routes to the sport page, so clicking navigates there and begins. Picks
 *  the signed-in vs signed-out script from the current session; the sport falls
 *  back to the schema default since this page isn't sport-scoped. Renders nothing
 *  if TourProvider isn't mounted (defensive — it lives at the root layout). */
export function TakeTourButton() {
  const tour = useOptionalTour();
  const { user } = useSession();
  const access = useAccess();
  const pathname = usePathname();

  if (!tour) return null;

  const start = () => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const sport = tourSportFromPath(pathname);
    const steps = user
      ? buildSharprTourSteps({ sport, isMobile, hasAccess: access.tier(sport) !== 'public' })
      : buildSignedOutSharprTourSteps({ sport, isMobile });
    tour.start(steps);
  };

  return (
    <button
      type="button"
      onClick={start}
      className="inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-colors"
    >
      <Compass className="w-4 h-4" />
      Take the interactive tour
    </button>
  );
}
